import React, { ComponentProps, FC, MouseEvent, useRef } from "react";
import { DialogOverlay, StyledModal, SubDialog, TrickySpan } from "../stitches/modal";
import { SizeProps } from "../utils/types";

type StitchesModal = ComponentProps<typeof StyledModal>;

export interface ModalProps extends StitchesModal {
  isOpen?: boolean;
  onClose: () => void;
  closeOnOutsideClick?: boolean;
  size?: SizeProps;
}

export const Modal: FC<ModalProps> = ({ isOpen = false, onClose, closeOnOutsideClick = true, size = "base", children, ...props }) => {
  const modalRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (e: MouseEvent) => {
    if (modalRef.current && modalRef.current.contains(e.target as Node)) {
      // inside click
      return;
    }
    // outside click
    onClose();
  };

  return (
    <div
      onClick={e => {
        if (closeOnOutsideClick) handleClickOutside(e);
      }}
      style={{
        position: "fixed",
        zIndex: 10,
        top: "0px",
        right: "0px",
        bottom: "0px",
        left: "0px",
        overflowY: "auto",
        display: isOpen ? "" : "none",
      }}
    >
      <SubDialog>
        <DialogOverlay />
        {/* This tricks the browser to center the modal */}
        <TrickySpan>&#8203;</TrickySpan>
        <StyledModal {...props} ref={modalRef} size={size}>
          {children}
        </StyledModal>
      </SubDialog>
    </div>
  );
};
